import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './LanguageSelector.html?raw';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { CountryCode2, CountryCodeIti, Language, LanguagesEnglish, LanguagesGerman, PitLanguageMap, PitLanguageSuffix } from "../UI/MultiLangEdit/TranslationsForm/TranslationsFormTypes";
import FloatingMenu from '../UI/Floating/Menu';

class LanguageSelector extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private availableLanguages: Array<{ code: Language, flagIcon: CountryCodeIti }> = null;

    private arrowicon: HTMLElement;

 
    private _onClick_ToggleDropdown(evt: MouseEvent) {
        this.openDropdown(evt);
    }

    openDropdown(evt: MouseEvent) {
        if (!evt) return;

        let menu = new FloatingMenu();

        for (let language of this.availableLanguages) {

            let icon = this.createFontawesomeIcon("flag-icon flag-icon-" + language.flagIcon)
            menu.addEntry({
                label: window.currentLanguageCode == CountryCodeIti.D ? LanguagesGerman[language.code] as string : LanguagesEnglish[language.code] as string,
                callback: lang.hitch(this, this._onSelectLang, language.code),
                icon: icon
            });
        }

        menu.open(evt, null);
        
    }

    private _onSelectLang(code: Language) {
        let target: CountryCode2 = CountryCode2[code];

        if (!target) return; // target = CountryCode2.D;

        location.assign("?lang=" + target);
    }
  

    postCreate() {
        super.postCreate.apply(this, arguments as any);

        this.hideNode(this.domNode, !this.hasFeature("System/LanguageSelector"));


        let uiLanguages: Array<PitLanguageSuffix> = this.getCustomerSetting<Array<PitLanguageSuffix>>("uiLanguages");
        if (!uiLanguages?.length) uiLanguages = ["_D"];

        this.availableLanguages = [];
        for (let pitlang of uiLanguages) {
            let code: Language = PitLanguageMap[pitlang];
            let itiCode: CountryCodeIti = CountryCodeIti[code];

            this.availableLanguages.push({
                code: code,
                flagIcon: itiCode
            });
        }
    }
    startup() {
        super.startup.apply(this, arguments as any);


    }
}

export default mdsWidget(LanguageSelector);